<template lang="html">
  <div class="settingsGeocode setting-form-item">
    <div
      v-if="geoData && showPropositions"
      class="input-mask"
      @click="showPropositions = false"
    />
    <div class="setting-input-wrapper">
      <div class="setting-input-wrapper-geocode">
        <input
          ref="input"
          v-model="placeInput"
          :placeholder="inputPlaceholder"
          :autofocus="focus"
          type="text"
          class="inputPlace setting-input"
          @keyup="handleKeyOnPropositions"
          @input="handleInputChange"
          @focus="handeInputFocus"
        >
        <div
          v-if="geoData && placeInput && showPropositions"
          class="proposition-list"
        >
          <div
            v-for="(data, index) in geoData"
            :key="data.place_id"
            :class="{ active: index === active }"
            class="proposition-list-item"
            @click="selectPlace(data)"
            @mouseover="setActive(index)"
          >
            {{ data.display_name }}
          </div>
        </div>
      </div>
      <button
        type="button"
        @click="resetPlace"
      >
        <span class="UI-icon UI-delete" />
      </button>
    </div>
  </div>
</template>

<script>
import loadJson from '../utils/loadJson'
import bus from '../bus'
import debounce from 'lodash.debounce'

export default {
  name: 'SettingsForm',

  props: {
    focus: { type: Boolean, default: false }
  },

  data () {
    return {
      isLatLonSetManually: false,
      geoData: [],
      placeInput: '',
      precedentRequest: '',
      showPropositions: false,
      active: null,
      inputPlaceholder: this.$t('templates.location.enter-a-place')
    }
  },

  computed: {
    delayedRequestPlaces () {
      // Debounce is REQUIRED for Nomatim. See https://operations.osmfoundation.org/policies/nominatim/
      return debounce(this.requestPlaces, 1000)
    }
  },

  watch: {
    isLatLonSetManually (bool) {
      if (bool) {
        this.placeInput = ''
        this.inputPlaceholder = this.$t('templates.location.custom-coordinates')
      }
    }
  },

  mounted () {
    bus.$on('geocode-lat-lon-set-manually', this.setIsLatLonSetManually)
  },

  beforeDestroy () {
    bus.$off('geocode-lat-lon-set-manually', this.setIsLatLonSetManually)
  },

  methods: {
    async requestPlaces () {
      // Please use debounced function delayedRequestPlaces
      const newRequest = this.placeInput.replace(/[!?=&]/g, '').trim()
      if (newRequest.toLowerCase() !== this.precedentRequest) {
        const url = `https://nominatim.openstreetmap.org/search/${newRequest}?format=json&accept-language='${this.$i18n.locale}`
        this.geoData = await loadJson(url)
      }
      this.showPropositions = true
      this.precedentRequest = newRequest.toLowerCase()
    },

    handeInputFocus () {
      this.inputPlaceholder = this.$t('templates.location.enter-a-place')
      if (this.placeInput) this.showPropositions = true
    },

    handleInputChange () {
      this.showPropositions = false
      if (this.placeInput) this.delayedRequestPlaces()
    },

    selectPlace (place) {
      this.showPropositions = false
      this.$refs.input.blur()
      this.placeInput = place.display_name
      const placeSelected = {
        latitude: place.lat,
        longitude: place.lon,
        name: place.display_name
      }
      bus.$emit('geocode-place-selected', placeSelected)
      this.setIsLatLonSetManually(false)
    },

    setIsLatLonSetManually (boolean) {
      this.isLatLonSetManually = boolean
    },

    setActive (index) {
      if (index !== this.active) this.active = index
    },

    resetPlace () {
      this.placeInput = ''
    },

    handleKeyOnPropositions (e) {
      if (!this.showPropositions) return

      switch (e.key) {
        case 'Escape':
          this.showPropositions = false
          break

        case 'ArrowUp':
          if (this.active === null) {
            this.active = 0
          } else if (this.active > 0) {
            this.active--
          }
          break

        case 'ArrowDown':
          if (this.active === null) {
            this.active = 0
          } else if (this.active < this.geoData.length - 1) {
            this.active++
          }
          break

        case 'Enter':
          if (this.active !== null && this.geoData && this.showPropositions) {
            this.selectPlace(this.geoData[this.active])
          }
          break

        default:
          break
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/variables";
@import "~@/assets/styles/buttons";

.settingsGeocode {
  align-self: flex-start;
  flex-grow: 1;

  .input-mask {
    opacity: 0;
    top:0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1;
    position: fixed;
  }

  .setting-input-wrapper-geocode {
    z-index: 2;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .proposition-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*border-radius: 8px;*/
    position: absolute;
    border: 1px solid #757573;
    top: 50px;
    z-index: 2;
  }

   .proposition-list-item {
     background-color: lighten(#364040, 4);
     border-bottom: 1px solid #757573;
     padding: 10px 28px 10px 18px;
     cursor: pointer;

     &.active {
       background-color: #ffffff;
       color: #364040;
     }
   }
}
</style>
